/**
 * MySpace 네비게이션 설정
 * @description 공통 Layout에서 사용하는 네비게이션 설정
 */
import { NavigationConfig, NavigationMenuConfig } from '@/common/layout';
import { 
  HiOutlineHome,
  HiOutlineBuildingOffice2,
  HiOutlineUserCircle
} from 'react-icons/hi2';

/**
 * 메뉴 설정
 */
const getMenuConfig = (): NavigationMenuConfig => ({
  items: [
    {
      id: 'my-space',
      label: '마이스페이스',
      icon: HiOutlineHome,
      path: '/my-space',
    },
    {
      id: 'space-management',
      label: '회사 관리',
      icon: HiOutlineBuildingOffice2,
      path: '/space-management',
    },
    {
      id: 'settings',
      label: '계정 설정',
      icon: HiOutlineUserCircle,
      path: '/settings',
    },
  ],
  supportEmail: 'info@factsheet.biz',
});

/**
 * 현재 경로에서 활성 메뉴 ID 반환
 */
const getActivePath = (pathname: string): string | null => {
  if (pathname === '/my-space' || pathname === '/notifications' || pathname.includes('/find-company')) {
    return 'my-space';
  }
  if (pathname.includes('/space-management')) {
    return 'space-management';
  }
  if (pathname === '/settings') {
    return 'settings';
  }
  return null;
};

/**
 * 메뉴 ID로 경로 반환
 */
const getPath = (menuId: string): string => {
  const paths: Record<string, string> = {
    'my-space': '/my-space',
    'space-management': '/space-management',
    'settings': '/settings',
  };
  return paths[menuId] || '/';
};

/**
 * MySpace 네비게이션 설정 Hook
 */
export const useMySpaceNavigationConfig = (): NavigationConfig => {
  return {
    menuConfig: getMenuConfig(),
    getActivePath,
    getPath,
    enableAuthCheck: false, // MySpace는 권한 체크 비활성화
  };
};

export default useMySpaceNavigationConfig;

